// 示例：直接引入某一个图标需要加 ?raw
// import add from './add.svg?raw'

// 导出图标
const icons = {}
const files = import.meta.glob('./*.svg', { eager: true, as: 'raw' })
Object.entries(files).forEach(([path, svg]) => {
  icons[path.match(/[^\.\/]+/)] = svg
})

export default icons
